import gql from 'graphql-tag'

export const CREATE_UPDATE_LR = gql`
mutation upsertLR($lr:[lr_insert_input!]!, $updateColumns: [lr_update_column!]!,
                        $address:[lrAddresses_insert_input!]!, $updateColumnsAddress: [lrAddresses_update_column!]!) {
  insert_lr(objects: $lr, on_conflict: {constraint: lr_pkey, update_columns: $updateColumns}){
    returning{id}
  }
  insert_lrAddresses(objects: $address, on_conflict: {constraint: lrAddresses_pkey, update_columns: $updateColumnsAddress}){
    returning{id}
  },
}`
